"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { type Locale } from "@/config/locale";
import { switchStorefrontLocalePath } from "@/lib/storefront/public-url";

/** Keep the selected variant, checkout identity and filters when changing only the language. */
export function useLocaleSwitchPath(currentLocale: Locale) {
	const pathname = usePathname();
	const query = useSearchParams().toString();

	return (locale: Locale) => {
		const path = switchStorefrontLocalePath(pathname, currentLocale, locale);
		return query ? `${path}?${query}` : path;
	};
}
